import './ProgrammeEvent.css';

function formatTime(time) {
    if (!time) return '';
    return time.slice(0, 5);
}

export default function ProgrammeEvent({
    startTime,
    endTime,
    title,
    speaker,
    affiliation,
    location,
    type,
    isTba,
    description,
    showTimes = true,
    showSpeakers = true,
    showAffiliations = true,
    showLocations = true,
    showDescriptions = true,
}) {
    const start = formatTime(startTime);
    const end = formatTime(endTime);

    const timeDisplay = isTba
        ? 'TBA'
        : end
            ? `${start} – ${end}`
            : start;

    const typeClass = type ? ` programme-event--${type}` : '';

    return `
        <div class="programme-event${typeClass}">

            <div class="programme-event__time">
                ${showTimes ? timeDisplay : ''}
            </div>

            <div class="programme-event__indicator"></div>

            <div class="programme-event__card">

                <h4 class="programme-event__title">
                    ${title ?? ''}
                </h4>

               ${
    showSpeakers && speaker
        ? `
            <div class="programme-event__speaker">
                ${speaker}
            </div>
        `
        : ''
}

               ${
    showAffiliations && affiliation
        ? `
            <div class="programme-event__affiliation">
                ${affiliation}
            </div>
        `
        : ''
}

                ${
    showLocations && location
        ? `
            <div class="programme-event__location">
                ${location}
            </div>
        `
        : ''
}
               ${
    showDescriptions && description
        ? `
            <p class="programme-event__desc">
                ${description}
            </p>
        `
        : ''
}

            </div>

        </div>
    `;
}
